'use strict';

angular.module('amexReconciliationApp')
  .service('ImportCsvService', function (Upload,$q) {
    var self = this;

     self.import = function (file, transactionId) {
            var q = $q.defer();
            if (transactionId===null) {
                q.reject('Error');

            } else {
                q.resolve(Upload.upload({
                    url: '/api/v1/importAllocations',
                    arrayKey: '',
                    data: {
                        file: file,
                        transactionId: transactionId
                    }
                }));

            }
            return q.promise;
        };


  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/ImportCsvService.js
// module id = 639
// module chunks = 0